import { render } from "./FormTransaction.vue?vue&type=template&id=0478a094&scoped=true"
import script from "./FormTransaction.vue?vue&type=script&lang=js"
export * from "./FormTransaction.vue?vue&type=script&lang=js"

import "./FormTransaction.vue?vue&type=style&index=0&id=0478a094&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0478a094"]])

export default __exports__